import { iRoleMissingResponseError } from "pages/DataHub/filters/types";

export const isRoleMissingResponseError = (
  data: any
): data is iRoleMissingResponseError => {
  return Boolean(
    Object.keys(data).includes('requiredPermission')
      && data.status === 403
  )
}